import classNames from 'classnames';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Tooltip } from 'shared/ui/Tooltip';

interface ContentCopyButtonProps {
  onClick: () => void;
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  tooltipClassName?: string;
  isDisabled?: boolean;
  date?: string;
}

export function RemoveButton({
  onClick,
  buttonClassName,
  iconClassName,
  tooltipClassName,
  className,
  isDisabled,
  date,
}: ContentCopyButtonProps) {
  const handleOnClick = () => {
    if (isDisabled) {
      return;
    }

    onClick();
  };

  return (
    <div className={className}>
      <Tooltip
        content={
          <div className="text-start">
            {isDisabled
              ? 'This date cannot be removed because it is two weeks or less before the event. Please contact your partnerships manager.'
              : 'Remove'}
          </div>
        }
        placement={isDisabled ? 'top' : 'bottom-start'}
        className={tooltipClassName}
        widthClass="max-w-[291px]"
        contentClass="!pl-3 !pr-2"
        {...getDataAutoTestAttributes([`remove-btn-tooltip-${date}`])}
      >
        <div
          className={classNames('h-[16px] w-[16px] ', buttonClassName)}
          onClick={handleOnClick}
        >
          <MaterialIcon
            className={classNames('flex items-center justify-center text-base select-none', iconClassName, {
              'cursor-pointer hover:text-red-500 text-slate-500': !isDisabled,
              'cursor-not-allowed text-slate-200': isDisabled,
            })}
          >
            delete_outline
          </MaterialIcon>
        </div>
      </Tooltip>
    </div>
  );
}
